import { useEffect, useState } from "react";
import Navbar from "@/components/landing/Navbar";
import Hero from "@/components/landing/Hero";
import Portfolio from "@/components/landing/Portfolio";
import InviteTypes from "@/components/landing/InviteTypes";
import Services from "@/components/landing/Services";
import BeforeAfter from "@/components/landing/BeforeAfter";
import CoupleStories from "@/components/landing/CoupleStories";
import ScheduleCall from "@/components/landing/ScheduleCall";
import FAQSection from "@/components/landing/FAQSection";
import InstagramGrid from "@/components/landing/InstagramGrid";
import Footer from "@/components/landing/Footer";
import WhatsAppFloat from "@/components/landing/WhatsAppFloat";
import MusicPlayer from "@/components/landing/MusicPlayer";
import LoadingSplash from "@/components/landing/LoadingSplash";
import CustomCursor from "@/components/landing/CustomCursor";
import useSeo from "@/hooks/useSeo";

export default function LandingPage() {
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);

  useSeo({
    title:
      "Digital Wedding Invitations Online | WhatsApp E-Invites | InvitationWala",
    description:
      "Beautiful digital wedding invitations delivered instantly on WhatsApp. 100% custom design, ready in 24 hours. Pan India & worldwide. Order in minutes!",
    canonical: "https://www.invitationwala.online/",
    ogImage:
      "https://customer-assets.emergentagent.com/job_portfolio-landing-49/artifacts/wssipa5q_WhatsApp%20Image%202026-04-18%20at%2013.07.06.jpeg",
  });

  return (
    <main
      className="relative min-h-screen overflow-x-hidden"
      style={{ background: "var(--iw-bg)" }}
      data-testid="landing-root"
    >
      <LoadingSplash />
      <CustomCursor />
      <Navbar />
      <Hero />
      <Portfolio />
      <InviteTypes />
      <BeforeAfter />
      <Services />
      <CoupleStories />
      <ScheduleCall />
      <FAQSection />
      <InstagramGrid />
      <Footer />
      <WhatsAppFloat />
      <MusicPlayer />
    </main>
  );
}
